export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "",
    "notifications.rp_has_been_updated": "Gold Residential Project is geüpdatet",
    "moduleTitle.files": "Documenten",
    "label.coordinator": "Coördinator",
    "sidebar.translations_managment": "",
    "table.file": "Document",
    "label.report_overview": "",
    "label.parent_agreement": "Akkoord van ouder&#39;s",
    "parentalConsent.i_consent_to_and_understand_that": "6. Ik geef toestemming en begrijp dat foto's genomen kunnen worden van de deelnemer wanneer hij/zij deelneemt aan activiteiten gerelateerd aan de Award en dat deze fot's gebruikt kunnen worden voor promotionele doeleinden. Het toestemmingsformulier voor het openbaar maken van het materiaal is getekend door zowel de deelnemer als zijn/haar ouder/voogd.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Ik begrijp dat deelnemers alle onderdelen volgens de criteria, afspraken en standaarden in het Online Record Book moeten volbrengen en afronden. De regels van de Award unit met betrekking tot veiligheid, beoordeling en het afronden van de Expeditie zijn leidend en ik begrijp dat de Award unit de deelname van een deelnemer kan stoppen als deze hieraan niet kan voldoen.",
    "table.end_date": "Einddatum",
    "label.activation_date": "Activatie datum",
    "label.report": "",
    "label.award_is_offline": "",
    "label.pending_changes": "In afwachting van veranderingen...",
    "errors.min_nights_required": "",
    "label.country": "Land",
    "notifications.award_leader_has_been_returned": "Awardbegeleider is gewijzigd",
    "notifications.participant_has_been_updated": "Deelnemer is geüpdatet",
    "label.phone_number": "Telefoonnummer",
    "roles.aj_assessor": "Expeditie Assessor",
    "notifications.person_state_has_been_changed": "",
    "pageTitle.dashboard": "Dashboard",
    "moduleTitle.global_payment_method": "",
    "label.organization_type": "Type organisatie",
    "button.account_settings": "Account instellingen",
    "notifications.contact_has_been_updated": "Contact geüpdatet",
    "participant.recover_password": "Herstel wachtwoord",
    "notifications.assessment_request_has_been_sent": "",
    "button.unassign": "",
    "label.start_date": "Start datum",
    "label.assign_labels": "",
    "sidebar.participants": "Deelnemers",
    "roles.coordinator": "Coördinator",
    "label.organization_contact": "",
    "tabs.customization": "Aanpassing",
    "sidebar.award_units": "Award Centres",
    "button.change_goal": "Verander doel",
    "translationsManagement.selectProject": "",
    "award.rp": "Gold Residential Project",
    "label.size": "",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Activiteit is goedgekeurd",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "",
    "notifications.template_has_been_removed": "Template is verwijderd",
    "button.award_settings": "",
    "pageTitle.payment": "",
    "tasks.return_award": "Bewerk Award",
    "label.link": "",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Mijn Regionaal Kantoor - relaties",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Aftekenen onderdeel",
    "table.logs": "Posts",
    "moduleTitle.remove_file": "Document verwijderen?",
    "label.email_confirmed": "",
    "notifications.activity_has_been_returned": "Activiteit is bewerkt",
    "label.note": "Opmerking",
    "button.show": "",
    "tabs.adventurous_journey": "Expeditie",
    "sidebar.my_todolist": "",
    "label.here": "",
    "organisation.change_award_mode": "",
    "table.note_from_al": "Opmerking van Awardbegeleider",
    "label.gender": "Geslacht",
    "moduleTitle.remove": "Verwijderen?",
    "errors.must_be_less_than": "",
    "button.logout": "Uitloggen",
    "label.no_selected_participants": "",
    "button.new_aj_event": "",
    "label.employement_status": "Werknemersstatus ",
    "tabs.logs": "Posts",
    "tabs.contacts": "Contacten",
    "label.option": "",
    "dashboard.charts": "Kaarten",
    "notifications.rp_has_been_approved": "Gold Residential Project is goedgekeurd",
    "pageTitle.new_participant": "Nieuwe deelnemer",
    "notifications.award_leader_has_been_approved": "Awardbegeleider is goedgekeurd",
    "moduleTitle.would_you_like_to_remove_leader_training": "Wil je de Awardbegeleiders training verwijderen?",
    "moduleTitle.update_configuration_value": "",
    "table.description": "Beschrijving",
    "table.organization": "Organisatie",
    "label.youtube": "YouTube",
    "label.author": "",
    "table.suitable_for_award_level": "Geschikt voor Award niveau",
    "label.content_update": "",
    "notifications.new_question_has_been_added": "",
    "pageTitle.nao_awards": "Landelijk bureau - Awards",
    "table.last_name": "Achternaam",
    "moduleTitle.adventurous_journey_detail": "",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Type locatie",
    "label.email_help_award_level": "",
    "label.date": "Datum",
    "label.previous_completed_award_place": "Award Centre?",
    "button.show_more": "Laat meer zien",
    "label.wwc_number": "",
    "button.filter": "Filter",
    "notifications.rp_has_been_returned": "Gold Residential Project is bewerkt",
    "pageTitle.residetial_project_assessor_report": "Gold Residential Project - Beoordelaars verslag",
    "label.generating": "",
    "moduleTitle.finance_system_data": "",
    "notifications.adventurous_journey_state_has_been_changed": "Expeditie status is veranderd",
    "route.levels": "Niveau's",
    "moduleTitle.activity_leader": "Activiteitenbegeleider",
    "tasks.approve_event": "Keur evenement goed",
    "tasks.reject_event": "Bewerk evenement",
    "table.region": "Regio",
    "pageTitle.nao_award_leaders": "Landelijk bureau - Award Begeleiders",
    "errors.must_be_at_least": "Moet tenminste {min} karakters bevatten",
    "table.title": "Titel",
    "table.last_activity": "Laatste activiteit",
    "tasks.delete_registration": "",
    "table.date_time": "",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. De Award Centres vinden je privacy belangrijk. De informatie die we hier vragen wordt alleen gevraagd voor deelname aan het Awardprogramma. Als je deze informatie niet wil geven dan kun je niet meedoen aan de Award. We gebruiken de gegevens om je informatie te sturen over Award activiteiten en evenementen waarvan we denken dat die interessant voor je zijn. We kunnen deze informatie ook delen met collega's en partners die betrokken zijn bij de activiteiten of het evenement. Als je je gegevens aan wil passen kun je contact opnemen met het landelijk kantoor van de Award, ook voor het privacy beleid van de International Award in Nederland. ",
    "aj.practice_journey": "Proefexpeditie",
    "notification.log_has_been_restored": "",
    "tabs.my_participants": "Mijn deelnemers",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Supervisor",
    "moduleTitle.your_parental_consent": "Je ouderlijke toestemming",
    "route.registration_participants": "Deelnemers registratie",
    "placeholder.start_typing": "Begint te typen...",
    "tasks.approve_award": "Keur Award goed",
    "route.registrations": "Registratie",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Een Expeditie evenement is aangemaakt",
    "states.supervisor_approval": "",
    "label.description": "Beschrijving",
    "button.leave_anyway": "Toch verlaten",
    "tabs.registrations": "Registraties",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "Landelijk bureau - registratie",
    "pageTitle.mro_logs": "Mijn Regionaal Kantoor - verslagen",
    "meta.page_not_found": "Pagina niet gevonden",
    "label.bulk_action_unsuccessful": "",
    "global.days": "Dagen",
    "table.review": "Beoordeling",
    "table.as_assessor_for": "",
    "roles.if_staff_statistical_user": "",
    "table.levels": "Niveaus",
    "label.suitable_for_level": "Geschikt voor niveau",
    "pageTitle.leaders": "Leiders",
    "moduleTitle.send_test_email": "",
    "pageTitle.tasks_removed_registration": "",
    "label.you_will_be_forced_to_login_again_after_change": "",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Onderdeel aftekenen",
    "pageTitle.payments": "Betalingen",
    "global.nights": "Nachten",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Selecteer organisatie",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "",
    "label.migrated_contact_email": "Overgezet mailadres van contact",
    "label.for_award_unit": "",
    "label.aj_template_note": "",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "",
    "label.consent_already_given_login": "",
    "participant.level_start_date": "{value} Startdatum",
    "sidebar.my_region_office": "Mijn Regionaal Kantoor",
    "states.section_signoff": "Aftekenen onderdeel",
    "moduleTitle.assessor_details": "",
    "moduleTitle.adventurous_journey_settings": "Instellingen Expeditie",
    "moduleTitle.note_from_al": "Opmerking van Awardbegeleider",
    "button.add_role": "Voeg rol toe",
    "table.run": "Ren",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "App gebruikershandleiding - Awardbegeleider",
    "tabs.section_approval": "Goedkeuring onderdeel",
    "roles.award_verifier": "Controleur Award ",
    "tabs.activity_approval": "Goedkeuring activiteit",
    "logs.add_log": "Voeg post toe",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "",
    "table.no_filtered_results": "Geen gefilterde resultaten ",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Details locatie",
    "label.optional": "(optioneel)",
    "errors.do_not_match": "Komt niet overeen",
    "label.use_comma_for_multiple_entries": "",
    "label.operating_authority": "Operating Authority",
    "label.activity_section": "",
    "notifications.you_have_been_logged_out": "Je bent uitgelogd",
    "table.finished": "Behaald",
    "button.same_as_billing": "Hetzelfde als facturering ",
    "table.payment": "Betaling",
    "table.current_level": "Huidige niveau",
    "button.view_nao": "",
    "table.email_confirmation": "E-mailbevestiging",
    "moduleTitle.shipping_address": "Verzendadres",
    "label.secondary_phone_type": "",
    "notifications.saved": "Opgeslagen",
    "pageTitle.all_participants": "Alle deelnemers",
    "label.first_name": "Voornaam",
    "label.oa_price": "",
    "table.award_mode": "",
    "tabs.api_keys": "",
    "award.award_detail": "Details Award",
    "tabs.user_management": "Gebruikersbeheer",
    "tabs.all_events": "Alle evenementen ",
    "notifications.history_record_has_been_removed": "",
    "award.no_data": "Geen informatie",
    "notifications.preparation_training_has_been_added": "Voorbereiding & Training is toegevoegd",
    "label.message": "",
    "notifications.participant_info_updated": "",
    "roles.nao_staff": "Staf nationaal kantoor",
    "tabs.adventurous_journeys": "",
    "label.gops": "",
    "route.upload": "Uploaden",
    "notifications.history_record_has_been_added": "",
    "notifications.history_record_has_been_updated": "",
    "label.no_data": "Geen gegevens",
    "button.add_coordinator": "",
    "label.you_are_already_logged_as": "Je bent al ingelogd als",
    "route.my_national_office": "Mijn Landelijk kantoor",
    "tabs.leaders": "Awardbegeleiders",
    "label.email_confirmation": "E-mail bevestiging",
    "table.registration_date": "Registratiedatum",
    "notifications.role_has_been_removed": "Rol verwijderd",
    "button.move": "",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Detail",
    "table.award_unit": "Award Centre",
    "sidebar.settings": "Instellingen",
    "dashboard.leader_state": "Award Begeleiders - naar staat",
    "notifications.award_unit_has_been_approved": "Awardbegeleider is goedgekeurd",
    "states.awaiting_approval": "In afwachting van goedkeuring",
    "table.level": "Niveau",
    "table.action_requested": "",
    "label.organisation_mode": "",
    "label.no_note": "Geen notitie",
    "tabs.my_events": "Mijn evenementen",
    "notifications.participants_have_been_added": "Deelnemers zijn toegevoegd",
    "tabs.registration_questions": "",
    "button.delete_registration": "Verwijder registratie",
    "notifications.parental_consent_link_has_been_sent": "",
    "moduleTitle.select_role_organization": "Selecteer rol & organisatie",
    "label.experience": "",
    "translationsManagement.modal.title": "",
    "table.ic": "",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Wil je je account verwijderen?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Web gebruikershandleiding - Awardbegeleider",
    "label.journey_type": "Type Expeditie",
    "button.setup": "Setup",
    "tabs.my_national_office": "Award Nederland",
    "notifications.training_has_been_removed": "Training verwijderd",
    "label.nominated_and_identified_persons": "Geef aan wie alle data kan zien maar niet kan aanpassen",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "",
    "states.award_leader_signoff": "Aftekening Awardbegeleider",
    "table.award_signoff_attempts": "",
    "sidebar.regions": "Regios",
    "label.activity_deleted_note": "",
    "table.total": "",
    "errors.a_problem_has_occured_during_processing": "",
    "participant.participant_already_has_gold_award": "",
    "pageTitle.mro": "Mijn Regionaal Kantoor",
    "notifications.authorization_code_has_expired": "",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Expeditie evenementen",
    "global.loading": "Wordt geladen",
    "label.gnipp": "",
    "sidebar.registrations": "Registraties",
    "label.any_string": "",
    "contact.change_contact_status": "",
    "tabs.registration": "Registratie",
    "label.override_payment_note": "",
    "notifications.section_has_been_signed_off": "Onderdeel is afgetekend",
    "label.payment_date": "Betalingsdatum",
    "button.approve": "Keur goed",
    "moduleTitle.loggin_in": "",
    "label.website": "Website",
    "label.role": "Rol",
    "table.assessor_report": "Verslag Assessor",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "",
    "pageTitle.registrations": "Registraties",
    "parentalConsent.this_form_must_be_completed": "Dit formulier <strong?must</strong> worden ingevuld door een ouder/voogd voor deelnemers onder <strong> 18 jaar.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Gebruik tenminste één cijfer",
    "label.content_restore": "",
    "logs.hour": "Uur",
    "parentalConsent.i_have_read_and_understand": "7. Ik heb de vereisten van de verschillende levels van de Award gelezen en begrepen, die uiteen zijn gezet in de Outline van de Award (pagina 5 van dit formulier).",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Type Expeditie ",
    "notifications.search_cancelled": "",
    "route.detail": "Detail",
    "route.user_guide": "Gebruikershandleiding",
    "moduleTitle.history": "",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Deelnemers niet verboden aan een Award Centre",
    "states.inactive": "Inactief",
    "pageTitle.search_results": "",
    "button.proceed_to_login": "",
    "pageTitle.assessor_report_reject": "Wijzig Beoordelingsrapport",
    "notifications.contact_has_been_removed": "Contact verwijderd",
    "sidebar.operating_authorities": "Operating units",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Voorbereiding & Training",
    "route.user_guide_web_leader": "Web gebruikershandleiding - Awardbegeleider",
    "label.position_in_organization": "Positie in de organisatie",
    "errors.emails_dont_match": "E-mailadressen komen niet overeen",
    "route.my_participants": "Mijn deelnemers",
    "pageTitle.customisations": "Aanpassingen",
    "tabs.localization_files": "Lokalisatie van bestanden ",
    "table.assessor_approval": "Goedkeuring Assessor",
    "tabs.related_contacts": "Gerelateerde contacten",
    "table.aus": "Award Centres",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "",
    "label.if_your_download_doesnt_start": "",
    "route.independent_award_centres": "",
    "pageTitle.user_guide": "Gebruikershandleiding",
    "button.visit": "",
    "label.hours_first_letter": "",
    "pageTitle.my_organization_detail": "",
    "pageTitle.nao_detail": "Landelijk bureau - details",
    "button.change": "Verander",
    "award.aj": "Expeditie",
    "table.award_state": "",
    "pageTitle.tasks_award_signoff": "Award aftekenen",
    "pageTitle.regions": "Regios",
    "notifications.award_has_been_signed_off": "Award is afgetekend",
    "dashboard.award_approved_by": "Award goedgekeurd - naar niveau in 2016",
    "tabs.new_template": "Nieuw template",
    "error.parent_email_must_be_filled": "",
    "label.organisation_invoicing_name": "",
    "pageTitle.related_contacts": "Related contacts",
    "button.try_again": "",
    "label.cannot_be_change_to_another": "",
    "notifications.lead_coordinator_has_been_set": "",
    "label.training_name": "Naam training",
    "moduleTitle.new_contact": "Nieuw contact",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "",
    "notifications.award_level_has_been_changed": "",
    "label.subject": "",
    "route.silver_level": "Zilver niveau",
    "label.privacy_notice": "",
    "label.switch_organization": "Wissel organisatie",
    "meta.dofe_name": "The International Award for Young People",
    "route.profile": "Profiel",
    "roles.super_user": "Super-user",
    "dashboard.while_you_were_gone": "Ondertussen",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Tweede naam",
    "moduleTitle.new_activity": "",
    "organisation.would_you_like_to_remove": "",
    "label.state_province": "Staat/Provincie/Regio",
    "moduleTitle.your_home_address": "Je huisadres",
    "tabs.sign_offs": "Aftekenen",
    "moduleTitle.logs": "Posts",
    "button.view_more": "",
    "label.profile": "Profiel",
    "label.title": "Titel",
    "tabs.award_signoff": "Aftekenen Award",
    "label.post_code": "Postcode",
    "states.ceremony_certificate": "Awarduitreiking & Certificaat",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Ik geef toestemming voor het geven van persoonlijke gegevens (inclusief informatie van deelnemers) aan de Award Centre en de landelijke Award organisatie. Ik geef toestemming dat deze informatie wordt gebruikt volgens de Privacy Wetgeving in Nederland. ",
    "label.user_guide_web_participant": "Web gebruikershandleiding - Deelnemer",
    "label.award_unit_type": "Type Award Centre",
    "states.complete": "",
    "table.participant_state": "",
    "pageTitle.my_organization_payment": "",
    "table.approved": "Goedgekeurd",
    "pageTitle.my_organization_contacts": "Mijn Unit - contact adressen",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Verander naar <strong>{state}</strong> status?",
    "label.integer": "",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Wachtwoord is veranderd",
    "button.invite_assessor": "",
    "label.other_activity": "Andere activiteit",
    "notifications.parental_consent_has_been_sent": "Ouderlijke toestemming is verzonden",
    "button.revise": "Bewerk",
    "errors.end_date_must_be_after_start_date": "",
    "label.award_leader_signoff_date": "",
    "parentalConsent.i_understand_every_participant_must": "8. Ik begrijp dat iedere deelnemer moet deelnemen aan de Award via een Award Centre, die naar discretie deelnemers en voorgestelde Awardactiviteiten mag accepteren of weigeren.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Expeditie gedeelte",
    "global.day": "Dag",
    "moduleTitle.coordinator": "Coördinator",
    "label.region": "Regio",
    "button.add_history_record": "",
    "moduleTitle.adventurous_journey_template_settings": "Instellingen Expeditie Template",
    "notifications.personal_details_have_been_updated": "Persoonlijke informatie is geüpdatet",
    "sidebar.ics": "",
    "table.independent_award_centre": "",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Toestemming Ouder/Voogd",
    "label.photo_consent_given": "",
    "moduleTitle.authorising_contact": "Gemachtigde contactpersoon",
    "label.assessment_with_role": "",
    "dashboard.type_of_awards": "Award Centre type",
    "moduleTitle.payment": "Betaling",
    "states.in_progress": "In behandeling",
    "logs.no_logs": "Geen posts",
    "sidebar.my_office": "Mijn kantoor",
    "label.assessor_report": "Verslag van Assessor",
    "notifications.rp_has_been_signed_off": "Gold Residential Project is afgetekend",
    "tabs.labels": "",
    "sidebar.payments": "Betalingen",
    "meta.profile_questions": "",
    "label.fax": "",
    "label.email_help_custom_link": "",
    "label.last_name": "Achternaam",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Deelnemers - naar niveau",
    "tabs.award_leaders": "Awardbegeleiders",
    "label.i_confirm_that_ive_witnessed": "",
    "table.lead_coordinator": "",
    "states.deleted": "",
    "label.no_answers": "",
    "button.add": "Toevoegen",
    "label.exchequer_number": "",
    "label.waiting": "In afwachting",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Bewerk registratie",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Toestemming ouders/voogden",
    "table.assessor_approve": "Goedkeuren Assessor",
    "errors.some_fields_requires_your_attention": "Sommige velden vragen om je aandacht",
    "aj.qualifying_journey": "Echte expeditie",
    "route.awards": "Awards",
    "table.registration": "Registratie",
    "pageTitle.assessors": "",
    "notifications.award_has_been_updated": "Award is geüpdatet",
    "errors.must_be_one_of": "Moet een van {enums} zijn",
    "pageTitle.logs": "logs",
    "notifications.notifications.invitation_has_been_sent": "",
    "route.national_offices": "Landelijk kantoor",
    "notifications.training_has_been_updated": "Training geüpdatet",
    "label.parent_last_name": "Achternaam ouder/voogd",
    "table.leaders": "Awardbegeleiders",
    "states.award_level_complete": "Award voltooid",
    "button.reset": "",
    "sidebar.my_award_unit": "Mijn Award Centre",
    "pageTitle.all_aj_events": "All Expeditie activiteiten",
    "label.activity": "Activiteit",
    "moduleTitle.are_you_sure": "Weet je het zeker?",
    "route.gold_level": "Gouden niveau",
    "table.evidence": "Bewijs",
    "label.delivery_confirmed": "Levering bevestigd",
    "parentalConsent.as_the_parent": "Als ouder/voogd geef ik toestemming voor het gebruik van foto's door de Award voor promotie doeleinden.",
    "label.awardMode.offline": "",
    "tasks.approve_registration": "",
    "note.change_the_email_will_change": "Let op: het aanpassen van dit mailadres veranderd ook het mailadres van het overgezette mailadres.",
    "notifications.participant_has_been_approved": "Deelnemer is goedgekeurd",
    "label.reached_activity_limit": "",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Voorbereiding & Training is verwijderd",
    "pageTitle.settings": "Instellingen",
    "participant.level_registration_date": "{value} Registratie datum",
    "notifications.question_has_been_removed": "",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Award Begeleiders",
    "notifications.participants_have_been_transferred": "",
    "tabs.assessors": "",
    "sidebar.dashboard": "Dashboard",
    "pageTitle.independent_award_centers": "Onafhankelijke Award Organisaties",
    "label.search": "Zoeken",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Deelnemers notities",
    "errors.required_field": "Verlicht veld",
    "tasks.approve_task": "Goedkeuren Taak",
    "logs.edit_log": "Wijzig post",
    "table.state": "Status",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Sluiten",
    "label.parent_first_name": "Voornaam ouder/voogd",
    "parentalConsent.i_understand_that_the_participant": "1. Ik begrijp dat de deelnemer niet kan deelnemen aan de Award totdat dit formulier is ingevuld (inclusief toestemming van ouders/voogden) en is terug gestuurd naar de Award Nederland met de contributie (van toepassing), en is geaccepteerd door de organisatie.",
    "tabs.award_units": "Award Centres",
    "table.hours": "",
    "label.type": "Type",
    "notifications.adventurous_journey_has_been_removed": "Expeditie is verwijderd",
    "label.aj_is_not_approved_yet": "",
    "roles.authorizing_contact": "Gemachtigde contactpersoon",
    "table.date_submitted_to_office_signoff": "",
    "notifications.section_has_been_returned": "Onderdeel is bewerkt",
    "table.created_by": "Aangemaakt door",
    "route.user_guide_web_participant": "Web gebruikershandleiding - Deelnemer",
    "route.templates": "Sjablonen",
    "states.awaiting_sign_off": "Aftekening Awardbegeleider",
    "table.phone": "Telefoonnummer",
    "label.parental_consent": "",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Brons niveau",
    "label.invoice_currency": "",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "",
    "notifications.contact_has_been_created": "Contact aangemaakt",
    "pageTitle.profile_questions": "Vragen voor profiel",
    "table.observation_files": "",
    "table.participants": "Deelnemers",
    "tasks.no_evidence": "Geen bewijs geleverd",
    "button.edit": "Wijzig",
    "moduleTitle.leader": "Awardbegeleider",
    "notifications.new_template_has_been_updated": "Nieuwe template is geüpdatet",
    "table.name": "Naam",
    "label.no_results": "Geen resultaten",
    "moduleTitle.documents": "",
    "button.invite": "",
    "label.goal": "Doel",
    "pageTitle.nao_award_units": "Nationaal kantoor - Award Centre",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Gebruik minimaal {length} karakters",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Rol verwijderen?",
    "label.total": "",
    "label.delete_participant_award_info": "",
    "route.leaders": "Award Begeleider",
    "table.start_date": "Startdatum",
    "moduleTitle.coordinators": "",
    "button.create": "Creëer",
    "tabs.awards": "Awards",
    "parentalConsent.form_has_been_sent": "Ouderlijke toestemming is verstuurd",
    "states.journey_approval": "Goedkeuring Expeditie",
    "pageTitle.reports": "Verslagen",
    "table.journey_type": "Type Expeditie",
    "label.yes": "Ja",
    "pageTitle.assessor_report": "Beoordelaars verslag",
    "label.organization": "Organisatie",
    "notifications.award_leader_has_been_updated": "Awardbegeleider is geüpdatet",
    "moduleTitle.edit_role": "",
    "table.journey_activity": "Expeditie Activiteit",
    "label.location": "Locatie",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "",
    "global.assessor": "Beoordelaar",
    "moduleTitle.profile_questions": "Profielvragen ",
    "activity.cannot_edit_activity_if_award_in_state": "Kan de activiteit niet wijzigen als de Award in {state} status is.",
    "moduleTitle.assessor_detail": "Details Assessor",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Ik begrijp dat door deelname aan de Award via een Award unit, de deelnemer toegang krijgt tot het Online Record Book. De deelnemer kent de criteria die horen bij het Awardprogramma voor hij/zij start met de activiteiten voor de Award. Ik begrijp dat de Award unit de bevoegdheid heeft om te beslissen of de criteria zijn behaald voor een Bronzen, Zilveren of Gouden Award. Ik begrijp dat de deelnemer zelf verantwoordelijk is voor een goede verzekering voor activiteiten die buiten de organisatie/school plaats vinden. Ik begrijp dat ik voor de Expeditie zelf goed moet navragen hoe het precies zit met de verzekeringen. Ik begrijp dat ouders /verzorgers verantwoordelijkheid en aansprakelijkheid zijn voor de deelnemer.",
    "notifications.award_has_been_returned": "Award is bewerkt",
    "label.code_of_conduct": "",
    "button.new_contact": "Nieuw contact",
    "tabs.payments": "",
    "roles.naa_oa_staff": "",
    "label.switch_organisation_hint": "",
    "label.expiration_date": "",
    "tabs.participants": "Deelnemers",
    "table.practice": "Proefexpeditie",
    "notifications.one_activity_has_to_remain": "",
    "label.qualifications": "",
    "states.organization_approval": "Goedkeuring organisatie",
    "errors.must_be_an_integer": "Moet een geheel getal zijn",
    "participant.send_confirmation_email_again_question": "Bevestigingsmail opnieuw verzenden?",
    "button.dismiss": "Ontheffen",
    "table.advice": "",
    "label.years_of_working_experience": "",
    "notifications.search_failed": "",
    "notifications.changes_have_been_saved": "",
    "moduleTitle.resend_parental_consent_link": "",
    "label.activity_type": "Type activiteit",
    "label.change_award": "",
    "label.email": "E-mailadres",
    "button.remove": "Verwijder",
    "button.download": "Downloaden",
    "label.vat_treatment": "",
    "pageTitle.aj_template_new": "Nieuw Expeditie sjabloon",
    "table.per_page": "Per pagina",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "",
    "tasks.revise_item": "Bewerk item",
    "button.resend_parental_consent": "",
    "table.weeks_completed_required": "Weken voltooid/vereist",
    "label.last_modified": "",
    "table.major": "Hoofdonderdeel",
    "label.vat_number": "",
    "errors.passwords_dont_match": "Wachtwoorden komen niet overheen",
    "table.country": "",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Autorisatie code is niet langer geldig",
    "errors.must_be_no_more_than": "Mag maximaal {max} karakters bevatten",
    "notifications.event_has_been_rejected": "Evenement is bewerkt",
    "tabs.customizations": "Aanpassingen",
    "label.name_organization": "Naam",
    "button.add_log": "Voeg post toe",
    "moduleTitle.invite_assessor": "",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "",
    "label.repeat_email": "Herhaal e-mailadres",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Rol is geüpdatet",
    "roles.if_staff_stat_user": "",
    "participant.delete_account": "Verwijder account",
    "moduleTitle.would_you_like_to_remove_this_log": "Wil je deze post verwijderen?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Type Expeditie",
    "sidebar.manual_data_import": "",
    "label.created_after_date": "",
    "route.my_organization": "Mijn Award Centre",
    "button.show_list": "",
    "label.leaders": "Awardbegeleiders",
    "notifications.log_has_been_modified": "Post is gewijzigd",
    "button.upload_file": "",
    "moduleTitle.which_section_do_you_want_to": "",
    "tabs.bronze_level": "Brons",
    "notifications.participants_have_been_saved": "Deelnemers zijn opgeslagen",
    "pageTitle.aj_template_detail": "Expeditie onderdeel",
    "label.parent_email": "Ouder&#39;s / opvoeder&#39;s email",
    "map.appr_location": "Globaal adres",
    "notifications.log_has_been_removed": "Post is verwijderd",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Blijven",
    "table.previous_level": "Vorige niveau",
    "label.award_start_date": "",
    "assessor_report.returned_to_participant": "Teruggekeerd naar deelnemer",
    "pageTitle.tasks_assessors_registration": "",
    "aj.cannot_modify_award": "Je kunt het Awardniveau niet veranderen als de deelnemer niet is toegewezen aan een Awardbegeleider.",
    "moduleTitle.lost_internet_connection": "",
    "states.ceremony": "Awarduitreiking",
    "participant.reactivate_account": "Activeer account",
    "label.birthdate": "Geboortedatum",
    "pageTitle.assessment_send_successfully": "",
    "states.assessor_approval": "Goedkeuring Assessor",
    "award.change_award_level": "",
    "label.url_no_longer_valid": "",
    "button.update": "Updaten",
    "label.secondary_email": "",
    "button.role_edit": "",
    "table.award_leader": "",
    "label.level": "Niveau",
    "tasks.evidence": "Bewijs",
    "notifications.participant_is_already_in_list": "",
    "button.clear": "Wis",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Setup",
    "table.activity": "Activiteit",
    "label.copy_to_clipboard": "",
    "route.award_units": "Award Centres",
    "button.upload_photo": "",
    "table.hours_completed_required": "Voltooide / vereiste uren",
    "table.first_name": "Voornaam",
    "notifications.adventurous_journey_has_been_returned": "Expeditie is bewerkt",
    "pageTitle.national_offices": "Landelijk bureau",
    "notifications.you_have_been_logged_in": "Je bent ingelogd",
    "logs.offline": "",
    "moduleTitle.add_role": "Voeg rol toe",
    "label.user_app_guide_participant": "App gebruikershandleiding - Deelnemer",
    "notifications.file_has_been_removed": "Document is verwijderd",
    "label.send_message": "",
    "button.select": "Selecteer",
    "label.reason_of_deletion": "",
    "label.user_guide": "Gebruikershandleiding",
    "pageTitle.nao_participants": "Landelijk bureau - Deelnemers",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Geüpload door",
    "tasks.approve_item": "Goedkeuren item",
    "tasks.restore_participant_registration": "",
    "label.awardMode.hybrid": "",
    "table.first_activity_started": "Start activiteit",
    "moduleTitle.dates": "Data",
    "table.no_results": "Geen resultaten",
    "states.registration_approval": "Goedkeuring registratie",
    "table.breakdown_of_hours": "",
    "pageTitle.tasks_registration": "Deelnemers registratie",
    "button.create_new": "Creëer nieuwe",
    "sidebar.todolist": "Wat nog te doen",
    "label.active_participants": "Actieve deelnemers",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Bewerk taak",
    "organisation.change_organisation_state": "",
    "moduleTitle.roles": "",
    "label.no_config_key_available": "",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "Afgetekend door kantoor",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "Minuut",
    "label.last_activity": "Laatste activiteit",
    "sidebar.user_guide": "Gebruikershandleiding",
    "label.trained_award_leader": "Een getrainde Awardbegeleider",
    "table.progress": "Voortgang",
    "table.suboperating_authorities": "Sub-operaring Authorities",
    "activity.cannot_edit_activity_offline": "",
    "label.user_does_not_have_permissions": "Gebruiker <strong>{user}</strong> heeft geen toestemming deze inhoud niet zien.",
    "notifications.assessor_has_been_approved": "",
    "route.activity_approval": "Activiteiten goedkeuren",
    "moduleTitle.role": "Rol",
    "button.run": "Ren",
    "label.to": "",
    "notifications.file_has_been_updated": "Document is geüpdatet",
    "moduleTitle.edit_coordinator": "",
    "notifications.authorization_code_is_no_longer_valid": "Autorisatie code is niet langer geldig",
    "button.reject": "Bewerk",
    "label.label.participant_status": "Deelnemersstatus ",
    "award.gold_level": "Goud",
    "sidebar.variables": "Variabelen",
    "parentalConsent.checkbox_copy": "Ik verklaar dat ik de ouder/voogd van {firstName} {LastName} ben. Ik geef hem/haar hierbij toestemming om deel te nemen aan de Award in {organisationName} onder toezicht van de {awardLeader}. Ik heb de algemene voorwaarden van deelname aan de Award gelezen, begrepen en ik ga akkoord met de vereisten, zoals hierboven beschreven en op de website van Award Nederland.",
    "button.go_to_dashboard": "Ga naar dashboard",
    "button.add_option": "",
    "label.is_completed": "Is voltooid",
    "pageTitle.award_units": "Award Centres",
    "states.completed": "Voltooid",
    "button.adventurous_journey_template_settings": "Instellingen Expeditie Template",
    "label.system_rights": "Systeem rechten",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Inloggen",
    "label.name_of_the_unit": "Naam van de Unit",
    "button.send": "Verzenden",
    "award.ajs": "Expedities",
    "meta.payments_expired": "",
    "label.age": "Leeftijd",
    "notifications.payment_info_updated": "Betalingsinformatie is geüpdatet ",
    "table.is_completed": "Is voltooid",
    "table.invited_by": "",
    "route.files": "",
    "route.assessors": "",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Mijn deelnemers",
    "label.change_leader_status": "",
    "moduleTitle.parent_consent_form": "Formulier Toestemming Ouder/Voogd",
    "notifications.authorization_contact_has_been_set": "Beveogde contactpersoon is ingesteld",
    "button.close": "Sluiten",
    "label.independent_country": "Onafhankelijk land",
    "notifications.aj_preparation_training_has_been_returned": "Voorbereiding & Training Expeditie zijn bewerkt",
    "route.history_log": "Geschiedenis",
    "participant.account_settings": "Account instellingen",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "File url is niet gespecificieerd in de configuratie",
    "notifications.award_unit_has_been_removed": "",
    "table.parent": "Ouder",
    "label.mode_of_transport": "Vervoer",
    "label.parental_consent_email_info": "",
    "label.current_award": "Huidige Award",
    "table.action": "Handeling",
    "pageTitle.suboperating_authorities": "Sub-operating units",
    "notifications.award_leader_has_been_assigned": "Awardbegeleider is toegewezen",
    "tabs.sign_offs_locally": "Aftekenen lokaal",
    "Activity log has been restored": "",
    "sidebar.naos": "Landelijke Award Organisaties",
    "tabs.aj_templates": "Expeditie templates",
    "notifications.logging_out": "Uitloggen",
    "label.update_label": "",
    "button.organisation_settings": "",
    "tabs.independent_award_centers": "",
    "label.current": "",
    "table.location": "Locatie",
    "button.search": "Zoeken",
    "notifications.aj_preparation_training_has_been_approved": "Voorbereiding & Training Expeditie zijn goedgekeurd",
    "route.participants": "Deelnemers",
    "label.other_location_information": "Ander locatie informatie",
    "label.number_of_records": "",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. Ik sta garant om alle medische kosten (artsen, verplegers of ziekenhuiskosten) te betalen voor de deelnemer in het geval van een ongeval, ziekte of verlies wanneer de deelnemer deelneemt aan, of reist naar of terug, alle activiteiten of functies gerelateerd aan de Award.",
    "label.nationality": "Nationaliteit",
    "states.approval": "Goedkeuring",
    "notifications.something_went_wrong": "Oeps! Er is iets fout gegaan!",
    "aj.practice": "Proefexpeditie",
    "label.addressLine2": "Adres",
    "label.please_leave_a_note": "",
    "placeholder.select": "Selecteer",
    "label.observations": "Observaties",
    "label.aim": "Doel",
    "label.addressLine1": "Adres",
    "roles.aj_instructor": "",
    "meta.payments_waiting": "",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instructeur / gids",
    "moduleTitle.remove_customization_and_reset": "",
    "notifications.participant_registration_has_been_restored": "",
    "organisation.change_award_unit_mode": "",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Deelnemer is verwijderd",
    "label.language_settings": "Taal instellingen",
    "notifications.event_has_been_approved": "Evenement is goedgekeurd",
    "label.password": "Wachtwoord",
    "label.text": "",
    "table.observations": "",
    "notifications.participant_has_been_created": "Deelnemer is aangemaakt",
    "table.note_for_al": "Opmerking voor Awardbegeleider",
    "label.payment_confirmed": "Betaling bevestigd",
    "label.previous_completed_award_level": "Vorige Award (niet in het ORB)",
    "pageTitle.new_aj_event": "Nieuwe Expeditie activiteit",
    "label.backend": "",
    "label.relationship_to_participant": "Relatie met deelnemer",
    "award.physical_recreation": "Sport",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "",
    "label.supervisor_report": "Verslag van Supervisor",
    "table.role": "Rol",
    "route.user_guide_web_nao": "Web gebruikershandleiding - NAO",
    "label.page_not_found": "404 - Pagina niet gevonden",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Document is geüpload",
    "moduleTitle.address": "Adres",
    "moduleTitle.lead_coordinator": "",
    "pageTitle.login": "Aanmelden",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Gold Residential Project is georganiseerd",
    "moduleTitle.award_unit": "Award Centre",
    "button.remove_file": "",
    "moduleTitle.billing_address": "Facturatieadres",
    "pageTitle.my_aj_events": "Mijn Expeditie activiteiten",
    "route.tasks": "Taken",
    "button.confirm": "Bevestigen",
    "label.national_award_authority": "Nationaal Award kantoor ",
    "label.independent_award_centre": "Onafhankelijk Award Centrum",
    "award.generate_award_report": "",
    "route.my_region_office_customization": "",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Aanvraag wachtwoord wijziging is verzonden",
    "tabs.detail": "Detail",
    "participant.change_participant_status": "",
    "table.key": "",
    "label.find_address": "Adres vinden",
    "notifications.assessor_has_been_rejected": "",
    "label.transfer_participants": "",
    "button.continue_to_payment_gateway": "",
    "notifications.participant_registration_has_been_removed": "",
    "moduleTitle.page_not_found": "404 - Pagina niet gevonden",
    "route.adventurous_journeys": "Expedities",
    "states.registration_assessment": "Beoordeling registratie",
    "heading.change_award_unit_mode": "",
    "label.user_guide_web_nao": "Web gebruikershandleiding - NAO",
    "tabs.silver_level": "Zilver",
    "table.paid_by": "",
    "label.your_report_has_been_successfully_sent": "Je verslag is succesvol verzonden",
    "sidebar.my_organization": "Mijn Unit",
    "pageTitle.participants": "Deelnemers",
    "notifications.preparation_training_has_been_updated": "Voorbereiding & Training is geüpdate",
    "moduleTitle.server_is_unreachable": "",
    "label.last_activity_date": "",
    "award.bronze_level": "Brons",
    "moduleTitle.award_units": "",
    "table.completed": "Voltooid",
    "moduleTitle.revise_message": "Wijzig bericht",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "",
    "button.change_password": "Wijzig wachtwoord",
    "label.nao_price": "",
    "label.payment_state": "Betalings status",
    "label.wwc_expired": "",
    "label.award_office_signoff_date": "",
    "label.award_unit": "Award Centre",
    "award.gold_level_short": "Goud",
    "moduleTitle.other_info": "Andere informatie",
    "table.note": "Opmerking",
    "label.search_by_email_first_or_last": "Zoek via e-mail adres, op voor- of achternaam",
    "tabs.history": "Geschiedenis",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Niet toegewezen deelnemers",
    "table.main_award_leader": "Hoofd Awardbegeleider",
    "parentalConsent.i_as_the_parent": "3. Ik begrijp dat sommige activiteiten als risicovol beschouwd worden en dat risicovolle activiteiten soms niet onder verzekeringspolissen vallen van de Award Organisatie. Ik begrijp dat de verantwoordelijkheid van alle risico's die zich voordoen bij de deelnemer's deelname aan de Award bij de Deelnemer ten dele vallen.",
    "label.state": "Status",
    "notifications.award_leader_has_been_removed": "",
    "tabs.organization_detail": "Details organisatie",
    "table.operating_authorities": "Operating Authorities",
    "label.available_labels": "",
    "modal.select": "Selecteer",
    "tabs.expired_payments": "",
    "moduleTitle.note_for_al": "Opmerking voor Awardbegeleider",
    "moduleTitle.confirm": "Bevestigen",
    "notification.new_activity_added": "",
    "notifications.award_leader_has_been_moved": "Awardbegeleider is verplaatst",
    "label.award_mode": "",
    "label.phone": "Telefoonnummer",
    "notifications.organization_has_been_updated": "Organisatie is geüpdatet",
    "moduleTitle.assessor": "Assessor",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Toestemming ouders/voogden",
    "label.date_of_delivery": "Datum van levering",
    "sidebar.assessors": "",
    "label.journey_activity": "Expeditie activiteit",
    "award.inactive_award": "",
    "label.end_date": "Eind datum",
    "label.orb_testing": "",
    "label.no_activities": "",
    "moduleTitle.please_confirm": "",
    "button.login_with_another_account": "Log in met een andere account",
    "tasks.reject_registration": "Bewerk registratie",
    "label.submitted_after_date": "",
    "label.update_translations_successful": "",
    "button.assign_leader": "Wijs Awardbegeleider toe",
    "table.already_running": "Al draaiende",
    "label.no": "Nee",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "",
    "label.my_experience": "Mijn ervaring",
    "notifications.adventurous_journey_has_been_approved": "Expeditie is goedgekeurd",
    "pageTitle.mro_detail": "Mijn Regionaal Kantoor - details",
    "moduleTitle.nao_specific_info": "Specifieke informatie Award Nederland",
    "label.preparing_document_for_import": "",
    "tasks.observations": "Observaties",
    "notifications.confirmation_email_has_been_sent": "Bevestigingsmail is verzonden ",
    "button.restore": "",
    "label.importing_file": "",
    "label.or_dont_agree": "",
    "moduleTitle.award_leader": "Awardbegeleider",
    "label.me": "(me)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "",
    "organisation.move_award_unit": "",
    "label.file_category": "",
    "notifications.connecting_to_server": "Verbinden met server...",
    "parentalConsent.i_understand_that_a_and_b": "11. Ik begrijp dat: <br/>a. de deelnemer geen auto of motor of ander voertuig mag besturen tenzij hij/zij een passend rijbewijs heeft en een inzittende verzekering heeft; en <br/>b. a. een deelnemer wordt niet vervoerd door iemand die niet betrokken is bij de Awardorganisatie als deze geen passend rijbewijs heeft and een inzittende verzekering heeft. ",
    "table.reason": "",
    "pageTitle.contacts": "Contacts",
    "states.award_leader_approval": "Goedkeuring Awardbegeleider",
    "meta.payments": "",
    "label.suboperating_authority": "Operating Partner",
    "route.my_region_office": "Mijn Regio Office",
    "states.registration_not_approved": "Registratie niet goedgekeurd",
    "label.direct_entrant": "",
    "tabs.all_participants": "Alle deelnemers",
    "tabs.payment": "Betaling",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Herhaal wachtwoord",
    "label.other_roles": "",
    "logs.hours": "Uren",
    "notifications.spreadsheet_has_been_imported_successfully": "",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Persoonlijke informatie",
    "label.bulk_action_emailing": "",
    "route.my_events": "Mijn evenementen",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Gebruik zowel hoofdletters als kleine letters",
    "tabs.removed_participant_registrations": "",
    "sidebar.mynao": "Mijn Landelijke Award Organisatie",
    "tabs.office_details": "Details Award Nederland",
    "label.major": "Hoofdonderdeel",
    "tabs.documents": "Documenten",
    "label.new_password": "Nieuw wachtwoord",
    "sidebar.adventure_journey": "Expeditie onderdeel",
    "pageTitle.customizations": "Aanpassingen",
    "moduleTitle.assessor_report": "{role} verslag",
    "label.registration_date": "Registratie datum",
    "notifications.training_has_been_added": "Training toegevoegd",
    "aj.qualifying": "Echte Expeditie",
    "moduleTitle.you_have_been_logged_out_session_terminated": "",
    "award.service": "Vrijwilligerswerk",
    "notifications.rp_state_has_been_changed": "Status Gold Residential Project is veranderd",
    "label.ctest_access": "",
    "table.created": "Aangemaakt",
    "tasks.revise_task": "Bewerk taak",
    "button.assign": "Toewijzen",
    "button.return": "Bewerk",
    "table.status": "Status",
    "button.restore_activity": "",
    "tabs.new_aj_event": "Nieuw Expeditie evenement",
    "roles.if_staff_viewer": "",
    "notifications.new_template_has_been_created": "Nieuwe template is gemaakt",
    "global.something_went_wrong": "Oeps! er is iets niet goed gegaan",
    "table.expire_day": "",
    "tabs.history_log": "Geschiedenis posts",
    "label.form_of_payment": "Manier van betalen",
    "button.add_training": "Voeg training toe",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "Mijn kwalificatie",
    "button.add_new_profile_question": "",
    "table.operating_authority": "",
    "table.aim": "Doel",
    "table.awards": "Awards",
    "participant.deactivate_account": "Deactiveer account",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Datum",
    "tasks.would_you_like_to_delete": "Wil je deze deelnemer verwijderen?",
    "notifications.configuration_value_has_been_updated": "De configuratiewaarde is geüpdatet",
    "ajTemplates.fill_from_template": "Vul vanuit sjabloon ",
    "contact.send_test_email": "",
    "moduleTitle.aj_preparation_and_training": "Voorbereiding & Training Expeditie",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "Ouder&#39;s / opvoeder&#39;s telefoonnummer",
    "label.nao_regulations": "",
    "award.skills": "Individueel talent",
    "label.reject_application": "",
    "leader.delete_account": "",
    "table.assign": "Toewijzen",
    "roles.aj_supervisor": "Expeditie Supervisor",
    "label.logout": "Uitloggen",
    "moduleTitle.award_leader_edit": "",
    "moduleTitle.training": "Training",
    "notifications.coordinator_has_been_removed": "",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Hoofd Awardbegeleider / Coördinator",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Voorbereiding",
    "table.delete": "Verwijderen",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Verslagen",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Operating units",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Bevestigd",
    "notifications.invitation_has_been_sent": "Uitnodiging is verstuurd",
    "pageTitle.independent_countries": "",
    "label.assessors_email": "",
    "tasks.approve_assessor_registration": "",
    "table.award_duration": "Duur Award",
    "notifications.organization_has_been_moved": "",
    "pageTitle.nao_payment": "Landelijk bureau - betaling",
    "participant.history_log": "Postgeschiedenis",
    "label.rejected_with_note": "",
    "label.already_running": "Al draaiende",
    "button.continue": "",
    "award.no_data_to_show": "Geen informatie beschikbaar",
    "participant.send_email_invitation_again_question": "Wil je opnieuw een e-mailuitnodiging versturen?",
    "label.reason_for_changing_assessor": "",
    "button.delete": "Verwijderen",
    "moduleTitle.requirements_and_conditions": "Algemene voorwaarden",
    "roles.leader": "Awardbegeleider",
    "label.if_download_doesnt": "",
    "dashboard.your_todo_list": "Persoonlijke activiteiten lijst",
    "notifications.award_unit_has_been_returned": "Award Centre is gewijzigd",
    "moduleTitle.participant_activities": "",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Actieve Awardbegeleiders",
    "aj.preparation": "Voorbereiding",
    "button.change_state": "Verander status",
    "label.current_password": "Huidig wachtwoord",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Contactinstellingen",
    "button.remove_photo": "Verwijder foto",
    "notifications.activity_has_been_setup": "Activiteit is georganiseerd",
    "errors.must_be_more_than": "Moet meer zijn dan {limit}",
    "table.goal": "Doel",
    "notifications.coordinator_has_been_set": "Coördinator is aangewezen",
    "label.cc": "",
    "label.duration": "Duur",
    "table.actions": "Handelingen",
    "participant.send_email_invitation_again": "Wil je opnieuw een e-mailuitnodiging versturen?",
    "moduleTitle.would_you_like_to_remove_participant": "Wil je de deelnemer verwijderen #{value}",
    "parentalConsent.i_authorise_employees": "4. Ik geef toestemming aan medewerkers van de Award Centre en andere mensen die betrokken zijn bij de organisatie van het Awardprogramma, om in geval van een ongeluk, verwonding, ziekte of verlies bij een deelnemer tijdens activieiten (en tijdens de heen- en terugreis) voor het Awardprogramma om zelf hulp te bieden en zo nodig medische hulp in te schakelen via een arts, verpleegkundige of een ziekenhuis.  ",
    "button.reload_page": "",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "E-mailadres",
    "label.new_goal": "Nieuw doel",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Ongeldig e-mailadres",
    "pageTitle.new_contact": "Nieuw contact",
    "sidebar.gops": "",
    "button.manage_participants": "Beheer deelnemers",
    "errors.invalid_phone_format": "Ongeldig telefoonnummer",
    "notifications.login_details_have_been_changed": "Inloggegevens zijn veranderd",
    "moduleTitle.participant_logs": "",
    "label.save": "Opslaan",
    "label.frequently_asked_questions": "",
    "label.city": "Woonplaats",
    "notifications.configuration_value_has_been_reset": "",
    "states.office_sign_off": "Nationaal kantoor heeft afgetekend",
    "button.save": "Opslaan",
    "button.import_data_from_selected_file": "",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Ik begrijp dat de deelnemer niet kan starten met een onderdeel van de Award tot ik duidelijk heb of de volwassene die de deelnemer heeft aangedragen, en die geen medewerker is van het team van de Award unit, voldoende ervaring heeft of gediplomeerd is om die activiteit op een goede en veilige manier te begeleiden. De deelnemer kan pas starten als ik van die volwassene de gevraagde informatie ontvang. ",
    "pageTitle.apiKeys": "",
    "label.international_region": "Internationale regio",
    "tabs.levels": "Niveaus",
    "tabs.additional_files": "",
    "label.continuation_level": "",
    "table.adventurous_journey_detail": "Details Expeditie",
    "button.set": "Instellen",
    "label.i_certify_that_as_the_assessor": "Ik verklaar dat de deelnemer voldoet aan de eisen van deze activiteit als {role}",
    "table.coordinator": "",
    "participant.send_confirmation_email_again": "Bevestigingsmail opnieuw verzenden?",
    "table.report": "Verslag",
    "label.update_translations_results": "",
    "table.observation_note": "",
    "label.view_more": "",
    "notifications.payment_link_has_been_reset": "",
    "table.type": "Type",
    "moduleTitle.updateConfigurationKey": "Update de configuratiecode",
    "sidebar.independent_award_centers": "Onafhankelijke Award Centra",
    "table.activity_type": "Type Activiteit",
    "label.awardMode.online": "",
    "table.data_state": "",
    "button.generate_report": "",
    "moduleTitle.assessed_by_award_leader": "Beoordeeld door Awardbegeleider",
    "table.child_protection_number": "",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Award state",
    "moduleTitle.overview": "Overzicht",
    "table.aj_detail": "Detail Expeditie",
    "pageTitle.tasks_activity_approvals": "Activiteiten goedkeuren",
    "label.section": "",
    "route.history": "Geschiedenis",
    "route.event_participants": "Deelnemers evenement",
    "participant.account_detail": "Account instellingen",
    "route.dashboard": "Dashboard",
    "table.payments": "Betalingen",
    "pageTitle.profile": "Profiel",
    "organisation.remove_organisation": "",
    "pageTitle.my_organization": "Mijn Unit",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "Hertog",
    "table.qualifying": "Echte Expeditie",
    "button.upload": "Uploaden",
    "button.resend": "",
    "label.filename": "",
    "label.change_parental_consent": "",
    "button.cancel": "Annuleer",
    "label.aply_to_all_langs": "",
    "route.customization": "Klantenspecifieke omschrijving",
    "errors.minimal_duration_is": "Minimale duur is 30 minuten",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Deelnemersstatus ",
    "award.bronze_level_short": "Brons",
    "label.phone_type": "Telefoon type",
    "global.night": "Nacht",
    "button.adventurous_journey_settings": "Instellingen Expeditie",
    "participant.leader_must_be_selected": "Selecteer een Awardbegeleider",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Gebruiker heeft Voorbereiding & Training toegevoegd",
    "table.approve": "Goedkeuren",
    "label.role_in_organisation": "Rol binnen de organisatie",
    "states.finished": "Afgerond",
    "label.created": "Aangemaakt",
    "button.back_to_home": "Terug naar Home",
    "label.options": "",
    "contact.next_level_invitation": "",
    "moduleTitle.activity_detail": "Detail activiteit",
    "route.section_signoff": "Onderdeel aftekenen",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Contact instelling",
    "label.transation_id": "Transactie ID",
    "notifications.activity_has_been_updated": "Activiteit is geüpdatet",
    "sidebar.awards": "Awards",
    "parentalConsent.images_consent": "Als ouder/voogd, geef ik toestemming voor het gebruik van afbeeldingen door Award Nederland",
    "participant.would_you_like_to_delete": "Wil je je account verwijderen?",
    "roles.user": "Gebruiker",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Geen resultaten",
    "moduleTitle.address_line_2": "Adres",
    "states.awaiting_office_sign_off": "Wachten op aftekenen door nationaal kantoor",
    "moduleTitle.export": "",
    "moduleTitle.address_line_1": "Adres",
    "notifications.participant_has_been_assigned": "Deelnemer is toegewezen",
    "roles.viewer": "Toeschouwer",
    "label.participants_total": "Totaal aantal deelnemers",
    "errors.auth_code_is_no_longer_valid": "",
    "label.file_is_not_available": "",
    "button.select_template": "Selecteer template",
    "label.payment": "Betaling",
    "award.silver_level_short": "Zilver",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "Je persoonlijke informatie",
    "aj.minimum_date_recommendation": "Aanbevolen minimum aantal dagen voor de Proefexpeditie en {name} is",
    "label.date_of_payment": "Datum van betalen",
    "button.view": "Bekijken",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Instellen deelnemers",
    "roles.assessor": "Assessor",
    "moduleTitle.coordinator_settings": "",
    "label.parent_relationship": "Ouder&#39;s relatie",
    "table.nao": "Award Nederland",
    "notifications.email_has_been_sent": "",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Sub-operating units",
    "route.award": "Award",
    "label.no_roles": "Geen rollen",
    "table.files": "",
    "aj.minimum_date_requirements": "Minimum aantal dagen voor de echte Expeditie en {name} is",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "",
    "moduleTitle.other_coordinators": "",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Keur Award registratie goed",
    "participant.invite_participant_to_next_level": "",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Awards",
    "warning.award_marked_as_paid": "",
    "table.edit": "Wijzigen",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "",
    "label.transaction_id": "Transactie ID",
    "table.suboperating_authority": "",
    "label.participant_survey": "",
    "label.created_by": "Aangemaakt door",
    "button.send_confirmation_email_again_question": "",
    "label.email_help_award_leader_email": "",
    "label.name": "Naam",
    "tabs.gold_level": "Goud",
    "pageTitle.award_documents": "Award documenten",
    "label.online_payments": "Online betalingen",
    "label.child_protection_number": "",
    "participant.send_password_recovery_email": "Stuur een e-mail om het wachtwoord te herstellen",
    "notifications.new_log_has_been_added": "Er is een nieuwe post toegevoegd",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Naam organisatie",
    "pageTitle.my_organization_templates": "Mijn Unit - Sjablonen",
    "pageTitle.award_leaders": "Awardbegeleiders",
    "label.status": "",
    "label.street": "Straat",
    "roles.if_staff_superuser": "",
    "table.licence_holder": "Licentie houder",
    "label.created_at": "Aangemaakt op",
    "table.section": "Onderdeel",
    "table.system_rights": "Systeemrechten",
    "label.iac_type": "",
    "label.other": "Anders",
    "moduleTitle.login": "Inloggen",
    "label.no_data_to_show": "Geen gegevens om weer te geven",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Je kunt het Award level niet veranderen als er deelnemers zijn toegewezen",
    "tabs.waiting_payments": "",
    "global.supervisor": "Supervisor",
    "notifications.new_role_has_been_added": "Nieuwe rol toegevoegd",
    "award.silver_level": "Zilver",
    "heading.change_awards_mode": "",
    "button.save_changes": "Wijzigingen opslaan",
    "organisation.would_you_like_to_move_award_unit": "",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Mijn Regionaal Kantoor - details",
    "table.started_at": "Gestart op",
    "parentalConsent.i_consent_to_the_award_unit": "2. Ik geef toestemming aan het Award Centre, en alle andere individuen - inclusief vrijwilligers* - die betrokken zijn bij of helpen met het organiseren van de Award, en ingehuurde chauffeurs, om de deelnemer te vervoeren met als doel deel te nemen aan activiteiten of functies gerelateerd aan de Award, zoals vereist. Ik begrijp dat het Award Centre me van te voren op de hoogte zal stellen wanneer en waar deze reizen zullen plaatsvinden.",
    "logs.minutes": "Minuten",
    "label.total_participants": "Totaal aantal deelnemers",
    "moduleTitle.contact_info": "Contactinformatie ",
    "table.payment_link": "",
    "errors.please_contact_your_local_award_staff": ""
}